export default "__VITE_ASSET__DpwWl7LO__";